import { useState } from "react";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { Checkbox } from "@mui/material";

const options = [
  { value: "Dexcom G7", label: "Dexcom G7" },
  { value: "Dexcom Stelo", label: "Dexcom Stelo" },
  { value: "Dexcom Proton", label: "Dexcom Proton" },
];

const ProductDropdown = ({ products, setProducts, isDisabled }: any) => {
  const [selectedValue, setSelectedValue] = useState([]);

  const handleChange = (event: any) => {
    const {
      target: { value },
    } = event;
    setProducts(typeof value === "string" ? [value] : value);
  };

  return (
    <FormControl sx={{ width: 400 }} fullWidth>
      <Select
        sx={{ fontSize: "1rem", fontWeight: "bolder", margin: "0" }}
        labelId="select-product-label"
        id="select-product"
        multiple
        value={products}
        disabled={isDisabled}
        onChange={handleChange}
        displayEmpty
        renderValue={(selected) => {
          if (selected?.length === 0) {
            return "Select a product";
          }
          return selected?.join(", ");
        }}
      >
        {options.map((option) => (
          <MenuItem
            sx={{ fontSize: "1rem", fontWeight: "bolder" }}
            key={option.value}
            value={option.value}
          >
            <Checkbox checked={products?.includes(option.value) || false} />
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ProductDropdown;
